import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const contactShow = (target) => {
  if (target) {
    const show = new Swiper(target, {
      modules: [Autoplay],
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
    })
  } else {
    console.warn('Contact Show: No target given')
  }
}

const defaultShow = (target) => {
  if (target) {
    const show = new Swiper(target, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: 3000
      }
    })
  } else {
    console.warn('Default Show: No target given')
  }
}

const eventShow = (target)  => {
  if (target) {
    const show = new Swiper(target, {
      slidesPerView: 1,
      spaceBetween: 15,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      }
    })
  } else {
    console.warn('Event Show: No target given')
  }
}

const featureShow = (target) => {
  if (target) {
    const show = new Swiper(target, {
      modules: [Navigation, Pagination],
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true
      },

      navigation: {
        nextEl: '.carousel-nav__arrow--next',
        prevEl: '.carousel-nav__arrow--prev',
      },

      pagination: {
        el: '.carousel-nav__dots--feature',
        clickable: true
      }
    })
  } else {
    console.warn('Feature Show: No target given')
  }
}

const galleryShow = (target) => {
	if (target) {
		const show = new Swiper(target, {
			modules: [Navigation],
			slidesPerView: 1,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: true
			},

			navigation: {
				nextEl: '.split-page-carousel-nav__arrow--next',
				prevEl: '.split-page-carousel-nav__arrow--previous',
			},
		})
	} else {
		console.warn('Feature Show: No target given')
	}
}

const socialShow = (target) => {
  if (target) {
    const show = new Swiper(target, {
      slidesPerView: 1,
      autoplay: {
        delay: 5000
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
          slidesPerGroup: 2
        }
      }
    })
  } else {
    console.warn('Social Show: No target given')
  }
}

const whatsOnShow = (target) => {
  if (target) {
    const show = new Swiper(target, {
      modules: [Autoplay],
      slidesPerView: 1,
      autoplay: {
        delay: 5000
      }
    })
  } else {
    console.warn('Whats On Show: No target given')
  }
}

/**
 * Initialise shows
 */
const initShows = () => {
  const contactShowEls = document.querySelectorAll('.js-contact-carousel')
  if (contactShowEls) {
    Array.from(contactShowEls, target => contactShow(target))
  }

  // Does not appear to be in use
  // // const defaultShowEls = document.querySelectorAll('.js-carousel')
  // // if (defaultShowEls) {
  // //   console.log('Init Default Show')
  // //   Array.from(defaultShowEls, target => defaultShow(target))
  // //   console.log('-------------------------')
  // // }

  const eventShowEls = document.querySelectorAll('.js-events-carousel')
  if (eventShowEls) {
    Array.from(eventShowEls, target => eventShow(target))
  }

  const featureShowEls = document.querySelectorAll('.js-feature-carousel')
  if (featureShowEls) {
    Array.from(featureShowEls, target => featureShow(target))
  }

  const featuredShowEls = document.querySelectorAll('.js-featured-carousel')
  if (featuredShowEls) {
    Array.from(featuredShowEls, target => defaultShow(target))
  }

  // Does not appear to be in use
  const galleryShowEls = document.querySelectorAll('.js-gallery')
  if (galleryShowEls) {
    Array.from(galleryShowEls, target => galleryShow(target))
  }

  // Does not appear to be in use
  // // const socialShowEls = document.querySelectorAll('.js-social-carousel')
  // // if (socialShowEls) {
  // //   console.log('Init Social Show')
  // //   Array.from(socialShowEls, target => socialShow(target))
  // //   console.log('-------------------------')
  // // }

  const whatsOnShowEls = document.querySelectorAll('.js-whats-on-carousel')
  if (whatsOnShowEls) {
    Array.from(whatsOnShowEls, target => whatsOnShow(target))
  }
}

export { initShows }
